import type { BridgePolicy } from '@gh/common/models'

function readNonEmptyString(value: unknown): string | null {
  if (typeof value !== 'string') {
    return null
  }
  const trimmed = value.trim()
  return trimmed.length > 0 ? trimmed : null
}

/** Best-effort payer label from an observed Bridge policy doc. */
export function bridgePolicyPayerDisplayName(policy: BridgePolicy): string | null {
  const snapshot = policy.snapshot
  if (snapshot && typeof snapshot === 'object') {
    const payer = snapshot.payer
    if (payer && typeof payer === 'object') {
      const payerName = readNonEmptyString((payer as Record<string, unknown>).name)
      if (payerName) {
        return payerName
      }
    }
  }
  return readNonEmptyString(policy.planName)
}
